import React from 'react';

const AffiliatesPayouts = () => {
  return <div>AffiliatesPayouts</div>;
};

export default AffiliatesPayouts;
